import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag } from "lucide-react";

export default function StickyBar() {
  const [orderInView, setOrderInView] = useState(false);

  useEffect(() => {
    const orderSection = document.getElementById("order");
    if (!orderSection) return;
    const observer = new IntersectionObserver(
      ([entry]) => setOrderInView(entry.isIntersecting),
      { rootMargin: "-15% 0px -15% 0px" }
    );
    observer.observe(orderSection);
    return () => observer.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {!orderInView && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-50 border-t border-[#2E9E6B]/20 bg-[#FBF9F4]/95 backdrop-blur-md md:hidden"
          data-testid="sticky-buy-bar"
        >
          <div className="flex items-center justify-between gap-3 px-4 py-3">
            <div>
              <p className="text-[10px] font-semibold text-[#566B63]">توصيل مجاني · دفع عند الاستلام</p>
              <p className="font-display text-lg font-black text-[#1F7A52]">129 درهم</p>
            </div>
            <a
              href="#order"
              data-testid="sticky-order-button"
              className="flex items-center gap-2 rounded-full bg-[#1F7A52] px-6 py-3 text-sm font-black text-[#FBF9F4] transition-colors active:bg-[#0F1E19]"
            >
              <ShoppingBag className="h-4 w-4" />
              اطلب الآن
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
